/* Section: header — dropdowns + mobile drawer + cart badge sync. */
(() => {
  const header = document.querySelector('[data-section="header"]');
  if (!header) return;

  // ————— Cart badge —————
  const badge = header.querySelector('[data-cart-count]');
  if (badge && window.TPHCart) {
    const update = () => {
      const n = window.TPHCart.count();
      badge.textContent = String(n);
      badge.style.display = n > 0 ? 'inline-flex' : 'none';
    };
    window.TPHCart.subscribe(update);
  } else if (badge) {
    badge.style.display = 'none';
  }

  // ————— Wishlist badge —————
  const wBadge = header.querySelector('[data-wishlist-badge]');
  if (wBadge && window.TPHWishlist) {
    window.TPHWishlist.subscribe((list) => {
      const n = list.length;
      wBadge.textContent = String(n);
      wBadge.style.display = n > 0 ? 'inline-flex' : 'none';
    });
  }

  // ————— Desktop dropdowns —————
  const items = header.querySelectorAll('.site-nav__item--has-panel');

  const closeAll = (except) => {
    items.forEach((it) => {
      if (it !== except) {
        it.classList.remove('site-nav__item--open');
        const btn = it.querySelector('.site-nav__link');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      }
    });
  };

  items.forEach((item) => {
    const btn = item.querySelector('.site-nav__link');
    if (!btn) return;

    // hover intent
    let hoverTimer = null;
    item.addEventListener('mouseenter', () => {
      clearTimeout(hoverTimer);
      closeAll(item);
      item.classList.add('site-nav__item--open');
      btn.setAttribute('aria-expanded', 'true');
    });
    item.addEventListener('mouseleave', () => {
      hoverTimer = setTimeout(() => {
        item.classList.remove('site-nav__item--open');
        btn.setAttribute('aria-expanded', 'false');
      }, 120);
    });

    // keyboard / click-to-toggle
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const isOpen = item.classList.contains('site-nav__item--open');
      closeAll();
      if (!isOpen) {
        item.classList.add('site-nav__item--open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // close on Escape or outside click
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAll();
  });
  document.addEventListener('click', (e) => {
    if (!header.contains(e.target)) closeAll();
  });

  // ————— Mobile drawer —————
  const toggle = header.querySelector('.nav-toggle');
  const drawer = document.querySelector('[data-mobile-nav]');
  const scrim = document.querySelector('[data-nav-scrim]');
  const closeBtn = drawer?.querySelector('.mobile-nav__close');

  const openDrawer = () => {
    drawer?.classList.add('mobile-nav--open');
    scrim?.classList.add('nav-scrim--open');
    document.body.style.overflow = 'hidden';
    toggle?.setAttribute('aria-expanded', 'true');
  };
  const closeDrawer = () => {
    drawer?.classList.remove('mobile-nav--open');
    scrim?.classList.remove('nav-scrim--open');
    document.body.style.overflow = '';
    toggle?.setAttribute('aria-expanded', 'false');
  };

  toggle?.addEventListener('click', openDrawer);
  closeBtn?.addEventListener('click', closeDrawer);
  scrim?.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeDrawer();
  });

  // mobile sub-menu toggles
  drawer?.querySelectorAll('[data-mobile-toggle]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const li = btn.closest('.mobile-nav__item');
      li?.classList.toggle('mobile-nav__item--open');
    });
  });
})();
